module.exports = __webpack_public_path__ + "img/yx_Logo.41c50f18.png";